import{jsx as t}from"react/jsx-runtime";import{SpinnerContainer as r}from"./styles.js";const o=()=>t(r,{});export{o as default};
